export default "__VITE_ASSET__CMvIYISq__"